import 'core-js/stable';
import 'regenerator-runtime/runtime';
import * as PIXI from 'pixi.js';
import { Game } from './framework/Game';
import { sceneMap } from './scenes/scenes';
import { ISgSdkSettings, ISgSdkHandler, TriggerAction } from "./sdk/types";
import '@azerion/h5-ad-providers';
import '@azerion/yx-feedback-client';
import { showInterstitial } from './sdk/showInterstitial';

declare global {
  interface Window {
    game: Game;
    PIXI: typeof PIXI;
    sgGameConfig: ISgSdkSettings["config"];
    sdkHandler: ISgSdkHandler;
    h5ads: any;
    azAdWrapper: any;
    h5branding: any;
    _azFeedback: any;
  }
}

export const appWidth = 730;
export const appHeight = 1085;

const game = new Game(
  {
    transparent: false,
    backgroundColor: 0xffffff,
  },
  {
    scenes: sceneMap,
    resizeHandler: () => {
      const mw: number = appHeight / window.innerHeight;
      const mh: number = appWidth / window.innerWidth;
      const scale: number = Math.max(mw, mh);
      return [
        window.innerWidth * scale,
        window.innerHeight * scale,
      ];
    },
  }
);

(async function() {
  const { config, handler } = await game.initialize();

  window.sgGameConfig = config;
  window.sdkHandler = handler;

  let _azerionIntegration: any = window['_azerionIntegration'];
  window.azAdWrapper = new window.h5ads.AdWrapper(_azerionIntegration.advType, _azerionIntegration.gdId);
  window._azFeedback.Wrapper.init(_azerionIntegration.fbType, {leaderboardName: 'bShooterChallengeSG'});

  //remove logging from the libraries
  window['console']['log'] = () => {};

  await window.h5branding.SplashLoader.getInstance({
    gameId: _azerionIntegration.gdId,
    gameName: 'Bubble Shooter Challenge',
    gameTitle: 'Bubble Shooter Challenge',
    libs: [],
    version: '1.0'
  }).create();

  await game.load();

  window.h5branding.SplashLoader.getInstance().setButtonCallback(async() => {
    window.h5branding.SplashLoader.getInstance().destroy();
    await showInterstitial();
    handler.trigger(TriggerAction.LOADING_COMPLETED);
  })
})();

window.game = game;
window.PIXI = PIXI;

export {
  game,
};
